module.exports = __webpack_public_path__ + "img/games-22.bb48c4ed.jpg";